import { render, staticRenderFns } from "./VChart.vue?vue&type=template&id=53b32e84&"
import script from "./VChart.vue?vue&type=script&lang=js&"
export * from "./VChart.vue?vue&type=script&lang=js&"
import style0 from "./VChart.vue?vue&type=style&index=0&id=53b32e84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports